import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { Supplier } from "../../supplier/supplier";
import { NewSupplierReferenceRequest } from "../new-supplier-reference-request";
import { Reference } from "../reference";
import { ReferenceService } from "../reference.service";
import { SupplierReference } from "../supplier-reference";

@Component({
  styleUrls: ["./update-supplier-reference-dialog.component.css"],
  templateUrl: "./update-supplier-reference-dialog.component.html"
})
export class UpdateSupplierReferenceDialogComponent implements OnInit {
  reference!: Reference;
  supplier!: Supplier;
  activeSupplierReference!: SupplierReference;

  public onSupplierReferenceUpdate!: (reference: Reference) => void;

  price!: number;
  newSupplierReferenceRequest = new NewSupplierReferenceRequest();

  constructor(
    public modal: NgbActiveModal,
    private referenceService: ReferenceService
  ) { }

  createSupplierReference() {
    this.newSupplierReferenceRequest.price = this.price * 100;
    this.referenceService.createSupplierReference(this.newSupplierReferenceRequest).pipe(
      tap(_ => this.modal.close()),
      tap(response => this.onSupplierReferenceUpdate(response.reference)),
    ).subscribe();
  }

  ngOnInit() {
    this.newSupplierReferenceRequest.isbn = this.reference.isbn;
    this.newSupplierReferenceRequest.supplierId = this.supplier.id;
    if (this.activeSupplierReference != undefined) {
      this.newSupplierReferenceRequest.supplierId = this.activeSupplierReference.supplier.id;
    }
  }

}